"use strict";

/**
 * @classdesc
 * Interface für WMS-Provider.
 *
 * @class
 * @extents gc.gis.GCWrappable
 * @memberof gc.gis.map
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {gc.gis.util.GCRequestManager} requestManager
 * @param {gc.gis.map.GCAbstractMap} map
 */
gc.gis.map.GCAbstractWMSProvider = function(requestManager, map)
{
	gc.gis.GCWrappable.call(this);

	this._requestManager = requestManager;
	this._map = map;
};
gc.gis.map.GCAbstractWMSProvider.prototype = Object.create(gc.gis.GCWrappable.prototype);

/**
 * Liefert das Capabilities des WMS.
 *
 * @abstract
 * @public
 * @param {string} url WMS-URL zum Laden des Capabilities
 * @param {function} onResponse Callback, die mit dem Capabilities als Parameter aufgerufen wird {@link gc.gis.format.GCWmtsCapabilities}
 * @throws {gc.gis.error.GCError} sofern das Capabilities-Dokument nicht geladen werden konnte
 */
gc.gis.map.GCAbstractWMSProvider.prototype.getCapabilities = gc.gis.abstractMethod;

/**
 * Sucht einen Layer im Capabilities.
 *
 * @abstract
 * @public
 * @param {Object} capabilities
 * @param {string} layerName
 * @return {Object} Layer Eigenschaften aus dem Capabilities
 */
gc.gis.map.GCAbstractWMSProvider.prototype.findLayer = gc.gis.abstractMethod;

/**
 * Sucht eine Menge von Layern im Capabilities.
 *
 * @abstract
 * @public
 * @param {Object} capabilities
 * @param {string[]} layerNames
 * @return {Object[]} Liste von Layer Eigenschaften aus dem Capabilities
 */
gc.gis.map.GCAbstractWMSProvider.prototype.findLayers = gc.gis.abstractMethod;

/**
 *
 * @param {Object} capabilities
 * @param {string[]} layers
 * @param {string[]} [opt_styles=[]]
 * @param {Object} [opt_options] optionale Parameter
 * @param {boolean} [opt_options.format] Bildformat (wenn nicht angegeben, das erste aus der Liste der unterstützten Formate im Capabilities)
 * @param {boolean} [opt_options.tiled=false] Bild in Tiles Laden ja/nein
 * @param {string} [opt_options.preferredCRS] gewünschtes CRS (wenn nicht angegeben oder vom WMS nicht unterstützt wird ein gültiges aus der Liste der unterstützten CRS im Capabilities)
 * @param {string} [opt_options.version] WMS-Version (wenn nicht angegeben, Version gemäß Capabilities)
 * @param {string} [opt_options.resource] OnlineResource des WMS (wenn nicht angegeben, OnlineResource gemäß Capabilities)
 */
gc.gis.map.GCAbstractWMSProvider.prototype.getLayerConfig = gc.gis.abstractMethod;

/**
 * Liefert für den übergebenen Layer einen GetMap-Request.
 *
 * @public
 * @method
 * @param {gc.gis.layer.GCRasterLayer} layer Raster-Layer-Instanz
 * @return {string}
 */
gc.gis.map.GCAbstractWMSProvider.prototype.getGetMapUrl = gc.gis.abstractMethod;
